<template>
  <component
    :is="component"
    v-bind="props"
    :data-medallia="medalliaFormId"
  />
</template>

<script lang="ts" setup>
import type { Target } from '#types/target'
import { CmsBaseButtonCvent, CmsBaseButtonEnroll, CmsBaseButtonSimple } from '#components'

const props = defineProps<Target>()

const medalliaFormId = computed(() =>
  props.behavior === 'feedback' ? props.actionLink?.formId || '' : null
)

const component = computed(() => {
  switch (props.behavior) {
    case 'cvent': return CmsBaseButtonCvent
    case 'enroll': return CmsBaseButtonEnroll
    default: return CmsBaseButtonSimple
  }
})
</script>
